<template>
  <article>
    <h3>
      <node-link
        :url="node.relative_url"
        :type="node.type"
        :nid="node.nid"
        :title="node.title"
      >{{node.title}}</node-link></h3>
    <field-date :simpleDate="true" class="text-left" :nid="nid"></field-date>
    <node-link
      :url="node.relative_url"
      :type="node.type"
      :nid="node.nid"
      :title="node.title"
      v-gtm-tracker="gtmType"
      class="image-wrapper"
    >
      <progressive-image class="disable-photoslider" :progressiveImage="progressiveImage" :alt="get(image, 'alt')" width="700" height="400" />
    </node-link>
  </article>
</template>

<script>
  import get from 'lodash/get'
  import isEmpty from 'lodash/isEmpty'
  import assignIn from 'lodash/assignIn'
  import { getSocialHeadLineAsTitle, rewriteImageSrc } from 'mixins/utilities'
  import FieldDate from 'components/node/fields/Date.vue'

  export default {
    name: 'news-bites-item',
    props: {
      nid: {
        type: String,
        required: true,
      },
    },
    methods: {
      isEmpty,
      get,
      assignIn,
    },
    computed: {
      title() {
        return getSocialHeadLineAsTitle(this.node.title)
      },
      image() {
        return get(this, 'node.images[0]', '')
      },
      progressiveImage() {
        return {
          src: rewriteImageSrc(get(this, 'image.style_700x400')),
          loading: rewriteImageSrc(get(this, 'image.style_220x137')),
          svg: {
            width: 700,
            height: 400,
          },
        }
      },
      gtmType() {
        return {
          ec: 'Tech City/News Bites Panel',
          ea: 'Tech City/News Bites Panel/Article/Click',
          el: get(this, 'node.relative_url', ''),
        }
      },
    },
    components: {
      FieldDate,
    },
    mounted() {
      this.$store.dispatch('fetchNode', { nid: this.nid })
    },
  }
</script>
<style scoped lang="scss">
article {
  margin: rem-calc(10 5);
  padding: rem-calc(0 0 10);
  border-bottom: 1px solid $tc-gray;
  &:last-child {
    border-bottom: 0;
  }

  @include respond-to("desktop") {
    &:nth-child(3n),
    &:nth-child(3n-1) {
      .image-wrapper {
        display: none;
      }
    }
  }

  @include respond-to("mobile") {
    position: relative;
    border: none;
    padding: 0;
    height: rem-calc(68.7);
    margin-bottom: rem-calc(17.3);
  }
}
h3 {
  font-size: rem-calc(15);
  font-weight: bold;
  margin: rem-calc(0 0 5);
  line-height: 130%;
  text-transform: none;

  a {
    color: $rose;
    text-decoration: none;

    &:hover {
      color: $rose-hover;
    }
  }
  @include respond-to("mobile") {
    margin-left: rem-calc(133);
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
}
time {
  font-size: rem-calc(12);
  display: inherit;
  @include respond-to("mobile") {
    margin-left: rem-calc(133);
    position: absolute;
    bottom: 0;
  }
}
a .progressive-image {
  display: block;

  @include respond-to("desktop") {
    margin-top: rem-calc(10);
  }
}

.image-wrapper {
  @include respond-to("mobile") {
    width: rem-calc(127.5px);
    height: rem-calc(68.7px);
    top: 0;
    position: absolute;
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// components/tech-city/widgets/NewsBitesItem.vue